<template>
  <div v-if="loaded">
    <s-toolbar>
      <template slot="left">
        <el-button type="success" plain @click="download()" title="Download Excel">
          <fa icon="file-excel" fixed-width size="lg"></fa>
        </el-button>
        <el-button type="success" plain @click="download(true)" title="Download Excel">
          Ολα
          <fa icon="file-excel" fixed-width size="lg"></fa>
        </el-button>
        <s-select
            :options="tanks"
            labelProp="name"
            large
            valueProp="id"
            filterable
            clearable
            placeholder="Φίλτρο δεξαμενής"
            v-model="selectedTank"
        ></s-select>
      </template>
      <template slot="center">
        <el-button
            type="warning"
            plain
            @click="$refs.fuelTable.appendRecord({status:'cr-load',time:unxnow()})"
            title="Διόρθωση δεξαμενης"
        >
          <i class="material-icons">vertical_align_center</i>
        </el-button>
      </template>
      <template slot="right">
        <el-button
            type="success"
            round
            title="Γέμισμα δεξαμενης"
            @click="$refs.fuelTable.appendRecord({status:'s-tank',vatFactor:0.24,time:unxnow()})"
        >
          +
          <i class="material-icons">ev_station</i>
        </el-button>
      </template>
    </s-toolbar>

    <s-table
        :cellClassFactory="cellDecorator"
        ref="fuelTable"
        v-if="loaded"
        v-model="fuelTrans"
        :topOffset="75"
        heightWish="90%"
        :pagging="41"
        :colDefinitions="colDefinitions"
        modx-processor="fuels/getlist"
        :r-query="qFuelTransactions"
        :lazyLoader="true"
        :addEmptyLine="false"
        @cell-change="handleFuelTransaction"
        @cell-clicked="removeFuelTransaction"
    ></s-table>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";

export default {
  name: 'TankFuels',
  data() {
    return {
      workingState: "vehicleSapply",
      fuelTrans: [],
      tanks: [],
      printData: null,
      printReady: false,
      loaded: false,
      selectedTank: null,
      page: 1,
      searchall: null,

      todayArrivals: [],
      todayDepartures: [],
      cols: {},
      dateFormat: "DD/MM/YY"
    };
  },
  methods: {
    download(mixedMode) {
      var q = {
        ...this.qFuelTransactions,
        download: true
      };
      if (mixedMode) q.view = "mixed";
      api.ajax_download("fuels/getlist", q);
    },
    cellDecorator(rowData) {
      const switchedCols = {
        tankLoadBefore: true,
        tankLoadBeforeDiff: true,
        load: true,
        tankLoadAfter: true,
        tankLoadAfterDiff: true,
        cost: true,
        depFactor: true,
        contact_id: true,
        depPrice: true
      };
      if (
          rowData.row.status != "s-tank" &&
          switchedCols[rowData.column.property]
      )
        return "locked";
      return "";
    },
    setWorkingState(key, keyPath) {
      this.vehicleSapply = key;
      _log_(key, keyPath);
    },
    handleClose(key, keyPath) {
    },
    ...mapActions({
      fetchAllOptions: "tags/fetchAll"
    }),
    removeFuelTransaction(e) {
      var vm = this;
      _log_("hell.RRs..", e);
      // _log_("trans.ss.go ii..", e);
      if (e.column.property == "delete") {
        if (!e.row.id) return;
        this.$confirm(
            "This will permanently delete the record. Continue?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning"
            }
        )
            .then(() => {
              api.removeObject("fuels", {objectId: e.row.id});
              vm.removeArrayElement(this.fuelTrans, e.row, "id");
            })
            .catch(() => {
            });
      }
    },
    async addExtraData(rec) {
      // _log_("tynk.ccc..", rec);
      if (rec.fuel_src_id) {
        const tr = await api.fetchProcessor("fuels/readings", {
          upToDate: rec.time,
          tankId: rec.fuel_src_id,
          currentLoadId: rec.id
        });
        // _log_("tynk.RRR..", tr,tr.data.results[0]);
        if (tr && tr.data && tr.data.results) {
          const r = tr.data.results[0];
          if (!r) {
            return rec;
            console.error("problem", r, rec);
          }
          const curentLoadBefore = parseFloat(r.srcLoad);
          if (rec.tankLoadBefore)
            rec.tankLoadBeforeDiff = parseFloat(
                rec.tankLoadBefore - curentLoadBefore
            ).toFixed(2);
          if (rec.tankLoadAfter && rec.load)
            rec.tankLoadAfterDiff = parseFloat(
                parseFloat(rec.tankLoadAfter) -
                (parseFloat(rec.load) + curentLoadBefore)
            ).toFixed(2);
          //  _log_("tynk..CHK.",  parseFloat(rec.tankLoadAfter),parseFloat(rec.load) ,  curentLoadBefore );
          // rec.tankLoadBeforeDiff=parseFloat(rec.tankLoadBefore)-
        }
      }
      return rec;
    },
    async handleFuelTransaction(e) {
      //process before edit
      const rup = await this.addExtraData(e.row);
      const tempSap = rup.contact_id;
      const data = await api.updateProcessor("fuels/updatetank", rup);
      _log_("upd...", data);
      if (data.contact_id != tempSap) {
        this.fetchAllOptions(["fuelSappliers"]); //refress
      }
      // _log_("upd...", data);
      if (data) this.updateArrayElement(this.fuelTrans, data, "id", true);
      this.fetchAllOptions(["readings"]);
    },
    async goPrintThis() {
      // var { data } = await api.fetchProcessor("bookings/vuebookings", {
      //   "bookingRange[]": this.bookingRange,
      //   idHotel: this.activeHotel,
      //   searchall: this.searchall,
      //   limit: 0
      // });
      // this.printData = data.results;
      this.loaded = true;
    },
    alert(msg) {
      _log_("hell...", msg, this.bookingRangeA.getTime());
    }
  },
  async mounted() {
    const date = new Date(),
        vm = this,
        fs = this.getList("fuelSrs");
    fs.forEach(fsrc => {
      if (fsrc.type == "tank") vm.tanks.push(fsrc);
    });
    this.loaded = true;
    // _log_("the rs///", this.rooms);
  },
  computed: {
    qFuelTransactions() {
      return {
        "timeRange[]": this.fuelsWorkingRange,
        view: "tanks",
        selectedTank: this.selectedTank
      };
    },
    ...mapGetters({
      getList: "tags/getList",
      fuelsWorkingRange: "user/fuelsWorkingRange"
    }),

    colDefinitions() {
      var rw = "380px";
      const vm = this;
      if (window.innerWidth < 500) rw = "150px";
      if (window.innerWidth < 700) rw = "240px";
      if (window.innerWidth < 1000) rw = "300px";
      return [
        {
          fixed: "left",
          prop: "status",
          editable: false,
          formatter(val) {
            if (val == "s-tank")
              return '<i class="material-icons">ev_station</i>';
            if (val == "cr-load")
              return '<i class="material-icons">vertical_align_center</i>';
          },
          width: "40px",
          label: ""
        },
        {
          prop: "time",
          label: "Η/Μ Ωρα",
          editable: true,
          width: "180px",
          forwardEditOnChange: true,
          formatter(val) {
            if (val) return dateHelper.format(val * 1000, "DD/MM/YYYY , HH:mm");
            return "&nbsp;";
          },
          editorcomponent: {
            type: "datetime",
            is: "s-dater"
          }
        },
        {
          prop: "fuel_src_id",
          width: "130px",
          label: "Tank",
          editable: true,
          editorcomponent: {
            is: "s-select",
            options: this.tanks,
            labelProp: "name",
            valueProp: "id",
            filterable: true,
            clearable: true
          }
          // viewcomponent: {
          //   is: "s-select",
          //   options: this.tanks,
          //   labelProp: "name",
          //   valueProp: "id",
          //   viewMode: true
          // }
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-tank") return true;
            return false;
          },
          prop: "tankLoadBefore",
          editable: true,
          width: "150px",
          label: "Μετρ.Πριν"
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-tank") return true;
            return false;
          },
          formatter(val) {
            return vm.formatNumber(val);
          },
          editorcomponent: {
            is: "s-number"
          },
          prop: "tankLoadBeforeDiff",
          editable: false,
          width: "150px",
          label: "Διαφ.Πριν"
        },
        {
          editorcomponent: {
            is: "s-number"
          },
          formatter(val) {
            return vm.formatNumber(val);
          },
          prop: "loadDelivered",
          editable: true,
          width: "150px",
          label: "Παραλαβη"
        },
        {
          editorcomponent: {
            is: "s-number"
          },
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-tank") return true;
            return false;
          },
          prop: "load",
          formatter(val) {
            return vm.formatNumber(val);
          },
          editable: true,
          width: "150px",
          label: "Τελ.Φορτιο"
        },
        {
          editorcomponent: {
            is: "s-number"
          },
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-tank") return true;
            return false;
          },
          formatter(val) {
            return vm.formatNumber(val);
          },
          prop: "tankLoadAfter",
          editable: true,
          width: "150px",
          label: "Μετρ.Μετα"
        },
        {
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-tank") return true;
            return false;
          },
          prop: "tankLoadAfterDiff",
          editable: false,
          width: "150px",
          label: "Διαφ.Μετα"
        },
        {
          editorcomponent: {
            is: "s-number"
          },
          formatter(val) {
            return vm.formatNumber(val);
          },
          prop: "cost",
          editable: true,
          width: "150px",
          label: "Κοστος",
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-tank") return true;
            return false;
          }
        },

        // {
        //   prop: "vatFactor",
        //   editable: true,
        //   width: "",
        //   label: "VAT",
        //   editWhen(rowData) {
        //     // _log_('???E..',rowData)0
        //     if (rowData.status == "s-tank") return true;
        //     return false;
        //   }
        // },
        {
          editorcomponent: {
            is: "s-number"
          },
          formatter(val) {
            return vm.formatNumber(val);
          },
          prop: "depFactor",
          editable: true,
          width: "150px",
          label: "ΣΥΝ.ΔΕΠ",
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-tank") return true;
            return false;
          }
        },
        {
          editorcomponent: {
            is: "s-number"
          },
          formatter(val) {
            return vm.formatNumber(val);
          },
          prop: "depPrice",
          editable: true,
          width: "150px",
          label: "Τιμη ΔΕΠ.",
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-tank") return true;
            return false;
          }
        },
        {
          prop: "depPrice",
          editable: false,
          width: "150px",
          label: "ΑΓΡ./Λ",
          formatter(val, cols, row) {
            if (row.cost && row.depPrice && row.load) {
              // _log_("a..." + row.vatFactor);
              var a = row.cost / row.loadDelivered,
                  b =
                      ((row.depPrice + row.depFactor) * (1 + row.vatFactor)) / 1000;
              return a.toFixed(2);
            }
            return "";
          }
        },
        {
          prop: "depPrice",
          editable: false,
          width: "150px",
          label: "ΔΕΠ/Λ",
          formatter(val, cols, row) {
            if (row.cost && row.depPrice && row.load) {
              // _log_("a..." + row.vatFactor);
              var a = row.cost / (1 + row.vatFactor) / row.load,
                  b =
                      ((row.depPrice + row.depFactor) * (1 + row.vatFactor)) / 1000;
              return b.toFixed(2);
            }
            return "";
          }
        },
        {
          prop: "contact_id",
          width: "180px",
          label: "Προμηθευτης",
          editable: true,
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.status == "s-tank") return true;
            return false;
          },
          editorcomponent: {
            is: "s-select",
            optionsRepo: "fuelSappliers",
            labelProp: "name",
            valueProp: "id",
            filterable: true,
            allowCreate: true,
            clearable: true
          }
          // viewcomponent: {
          //   is: "s-select",
          //   optionsRepo: "fuelSappliers",
          //   labelProp: "name",
          //   valueProp: "id",
          //   viewMode: true
          // }
        },
        {prop: "comments", editable: true, width: "180px", label: "Σχολια"},
        {
          prop: "delete",
          width: "60px",
          label: "X",
          fixed: "right",
          sortable: false,
          viewcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true
          },
          formatter(val, colDefs, row) {
            return "-";
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
          }
        }
      ];
    }
  }
};
</script>

<style>
.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}

.el-table__row .locked {
  background-color: darkgray;
}
</style>
